import { apiPrefix } from '@/app/services/miljnApiEndpointsWeb2'

export const blockTypeApiEndpointBasename = 'block-types'
export const blockTypeApiEndpoint = {
  viewAny: `${apiPrefix}/${blockTypeApiEndpointBasename}`,
  view: (blockTypeId: string) =>
    `${apiPrefix}/${blockTypeApiEndpointBasename}/${blockTypeId}`,
}
